// extracted by mini-css-extract-plugin
export var box = "_7n-1";
export var checkboxRow = "_7n-8";
export var checked = "_7n-2";
export var descriptionSpacer = "_7n-a";
export var disabled = "_7n-3";
export var icon = "_7n-6";
export var input = "_7n-0";
export var labelSpacer = "_7n-9";
export var medium = "_7n-5";
export var small = "_7n-4";
export var text = "_7n-7";